import React, { useMemo, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isTokenExpired } from "../../helpers/AccessControlUtils";
import { setRedirectPath } from "../../app/globalSlice";
import { useAuth } from "../../features/auth/AuthContext";
import Loader from "../shared/loader/Loader";
import { ensureDevAuthToken, isDevAuthSkipEnabled } from "../../helpers/devAuth";

export default function AuthGateLayout() {
  const dispatch = useDispatch();
  const { isLoading } = useAuth();
  const [devAuthPending, setDevAuthPending] = useState(() => {
    if (!isDevAuthSkipEnabled()) return false;
    const token = localStorage.getItem("authToken");
    if (!token) return true;
    return isTokenExpired();
  });
  const hasToken = !!localStorage.getItem("authToken");
  const isUserLoggedIn = useMemo(() => localStorage.getItem("authToken"), [hasToken]);
  const isAuthenticated = useMemo(
    () => isUserLoggedIn && !isTokenExpired(),
    [isUserLoggedIn]
  );

  useEffect(() => {
    if (!devAuthPending || isAuthenticated) {
      setDevAuthPending(false);
      return;
    }
    const devRole = window.location.pathname.startsWith("/audiologist")
      ? "audiologist"
      : undefined;
    ensureDevAuthToken(devRole).then((ok) => {
      setDevAuthPending(false);
      if (ok) window.location.reload();
    });
  }, [devAuthPending, isAuthenticated]);

  if (devAuthPending) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    const currentPath = window.location.pathname;
    dispatch(
      setRedirectPath(
        currentPath +
          window.location.search +
          window.location.hash
      )
    );
    const loginPath = currentPath.startsWith("/audiologist")
      ? "/audiologist/login"
      : "/login";
    return <Navigate to={loginPath} replace />;
  }

  if (hasToken && isLoading) {
    return <Loader />;
  }

  return <Outlet />;
}
